import { Controller } from "@hotwired/stimulus"

// 카테고리 편집 모달 컨트롤러
// - 모달 내 CRUD는 클라이언트 메모리에서 관리
// - "확인" 클릭 시 batch_update로 일괄 저장
// - "취소" 클릭 시 modals#close 로 처리 (서버 반영 없음)
export default class extends Controller {
  static targets = ["categoryList", "newNameInput"]

  pendingCreates = []   // [{ tempId, name }]
  pendingUpdates = {}   // { id: newName }
  pendingDestroys = new Set()
  tempIdCounter  = 0

  // ── 확인: 변경 사항 일괄 저장 ─────────────────────────────
  async confirm(event) {
    const brandId   = event.currentTarget.dataset.brandId
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content

    const body = {
      brand_id: brandId,
      creates:  this.pendingCreates.map(c => ({ name: c.name })),
      updates:  Object.entries(this.pendingUpdates).map(([id, name]) => ({ id, name })),
      destroys: [...this.pendingDestroys]
    }

    const res = await fetch("/pos_categories/batch_update", {
      method:  "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        "Accept":       "text/vnd.turbo-stream.html"
      },
      body: JSON.stringify(body)
    })

    if (res.ok) {
      const html = await res.text()
      window.Turbo.renderStreamMessage(html)
      window.dispatchEvent(new CustomEvent("modals:close"))
    }
  }

  // ── 카테고리 추가 (클라이언트 전용) ──────────────────────
  addCategory() {
    const input = this.newNameInputTarget
    const name  = input.value.trim()
    if (!name) return

    const tempId = `temp-${++this.tempIdCounter}`
    this.pendingCreates.push({ tempId, name })

    this.categoryListTarget.insertAdjacentHTML("beforeend", this.buildItem(tempId, name))
    input.value = ""
    input.focus()
  }

  // ── 인라인 편집 시작 ──────────────────────────────────────
  startEdit(event) {
    const item = this.getItem(event)
    item.querySelector("[data-name-display]").classList.add("hidden")
    const form = item.querySelector("[data-edit-form]")
    form.classList.remove("hidden")
    form.querySelector("input").focus()
  }

  cancelEdit(event) {
    const item = this.getItem(event)
    item.querySelector("[data-edit-form]").classList.add("hidden")
    item.querySelector("[data-name-display]").classList.remove("hidden")
  }

  // ── 이름 저장 (메모리 반영) ───────────────────────────────
  saveEdit(event) {
    const item    = this.getItem(event)
    const id      = item.dataset.categoryId
    const input   = item.querySelector("[data-edit-form] input")
    const newName = input.value.trim()
    if (!newName) return

    if (id.startsWith("temp-")) {
      const pending = this.pendingCreates.find(c => c.tempId === id)
      if (pending) pending.name = newName
    } else {
      this.pendingUpdates[id] = newName
    }

    item.querySelector("[data-name-display] span").textContent = newName
    item.querySelector("[data-edit-form]").classList.add("hidden")
    item.querySelector("[data-name-display]").classList.remove("hidden")
  }

  // ── 삭제 (메모리 + DOM 반영) ──────────────────────────────
  deleteCategory(event) {
    if (!confirm("카테고리를 삭제하시겠습니까?\n(확인 버튼을 눌러야 실제로 반영됩니다)")) return

    const item = event.currentTarget.closest("[data-category-item]")
    const id   = item.dataset.categoryId

    if (id.startsWith("temp-")) {
      this.pendingCreates = this.pendingCreates.filter(c => c.tempId !== id)
    } else {
      this.pendingDestroys.add(id)
    }

    item.remove()
  }

  // ── 헬퍼 ──────────────────────────────────────────────────
  getItem(event) {
    return event.currentTarget.closest("[data-category-item]")
  }

  buildItem(id, name) {
    return `
      <div id="pos_category_item_${id}"
           data-category-item
           data-category-id="${id}">
        <div data-name-display class="flex items-center justify-between py-3 px-4">
          <span class="font-bold flex-1 truncate">${name}</span>
          <div class="flex gap-2 flex-shrink-0">
            <button type="button"
                    data-action="pos-category-editor#startEdit"
                    data-category-id="${id}"
                    class="w-9 h-9 flex items-center justify-center border border-default-slate/50 rounded-full text-default-slate-dark hover:bg-default-slate/10">
              <i class="fa-solid fa-pen text-sm"></i>
            </button>
            <button type="button"
                    data-action="pos-category-editor#deleteCategory"
                    class="w-9 h-9 flex items-center justify-center border border-danger/50 rounded-full text-danger hover:bg-danger/5">
              <i class="fa-solid fa-trash text-sm"></i>
            </button>
          </div>
        </div>
        <div data-edit-form class="hidden flex items-center gap-2 py-3 px-4">
          <input type="text" value="${name}"
                 class="flex-1 min-w-0 border border-slate-300 rounded px-3 py-2 text-base">
          <button type="button"
                  data-action="pos-category-editor#saveEdit"
                  class="modal-pos-btn modal-pos-btn-fill whitespace-nowrap">
            저장
          </button>
          <button type="button"
                  data-action="pos-category-editor#cancelEdit"
                  data-category-id="${id}"
                  class="modal-pos-btn modal-pos-btn-border whitespace-nowrap">
            취소
          </button>
        </div>
      </div>`
  }
}
